import React from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import Sidebar from '../Sidebar.jsx'
import TopBar from '../TopBar.jsx'
import OfflineBanner from '../OfflineBanner.jsx'
import LockScreen from '../LockScreen.jsx'

function DebugBanner({ user, pathname }) {
  if (import.meta.env.PROD) return null
  return (
    <div className="px-3 py-2 text-xs bg-slate-50 border-b border-slate-200 text-slate-900">
      <strong>DEBUG</strong> - auth: <code>{String(!!user)}</code> - user:{' '}
      <code>{user ? user.username || user.email || user.id : 'null'}</code> - roles:{' '}
      <code>{user?.roles?.join(',') || '-'}</code> - path: <code>{pathname}</code>
    </div>
  )
}

export default function AppLayoutShell({
  user,
  onLogout,
  hasRole,
  locked,
  onUnlock,
  modules,
  isModuleEnabled,
  preferences,
  updatePreferences,
}) {
  const location = useLocation()
  const hideChrome = location.pathname === '/auth'

  return (
    <div className="h-screen flex flex-col bg-slate-50 text-slate-900 relative">
      {!hideChrome && (
        <TopBar
          connected={!!user}
          onLogout={onLogout}
          user={user}
          hasRole={hasRole}
          modules={modules}
          isModuleEnabled={isModuleEnabled}
        />
      )}

      <div className="flex-1 flex overflow-hidden">
        {!hideChrome && (
          <Sidebar
            connected={!!user}
            onLogout={onLogout}
            user={user}
            hasRole={hasRole}
            modules={modules}
            isModuleEnabled={isModuleEnabled}
            preferences={preferences}
            updatePreferences={updatePreferences}
          />
        )}

        <div className="flex-1 overflow-auto bg-surface-primary pilot-page">
          <DebugBanner user={user} pathname={location.pathname} />
          {!hideChrome && <OfflineBanner />}

          {!hideChrome && !user && (
            <div className="p-4 bg-amber-50 border-b border-amber-200 text-amber-900 text-sm">
              Vous n&apos;etes pas connecte. Allez dans <strong>Connexion</strong> pour vous
              authentifier.
            </div>
          )}

          <Outlet />

          {locked && <LockScreen user={user} onUnlock={onUnlock} onLogout={onLogout} />}
        </div>
      </div>
    </div>
  )
}
